angular.module('acme.common.service.posCloudConfiguration', [
  'acme.common.service.utils'
]).provider('PosCloudConfigurationService', PosCloudConfigurationServiceProvider);

/**
 * Service: posCloudConfiguration
 * https://acmeticketing.atlassian.net/wiki/spaces/PE/pages/121405866/POS+Configuration
 *
 * @constructor
 * @param {String} endpoint - the endpoint used
 * @param {Object} $http - angular $http service
 * @param {Function} unwrapAcmeResponse - helper function to unwrap http requests
 * @return {PosCloudConfigurationService} -
 */
function PosCloudConfigurationService (endpoint, $http, unwrapAcmeResponse) {

  return {
    getByTerminalId: getByTerminalId,
    getConfigurationByTerminalId: getConfigurationByTerminalId,
    upload: upload
  };

  function getByTerminalId (terminalId) {
    return $http.get(endpoint + '/' + terminalId)
      .then(unwrapAcmeResponse);
  }

  function getConfigurationByTerminalId (terminalId) {
    return $http.get(endpoint + '/' + terminalId + '/configuration', {
      params: { contentType: 'application/json'}
    })
      .then(unwrapAcmeResponse);
  }

  function upload(terminalId, configuration) {
    return $http.post(endpoint, {
      terminalId: terminalId,
      configuration: configuration
    })
      .then(unwrapAcmeResponse);
  }
}

function PosCloudConfigurationServiceProvider () {}

PosCloudConfigurationServiceProvider.prototype.setEndpoint = function (endpoint) {
  this.endpoint = endpoint;
};

PosCloudConfigurationServiceProvider.prototype.$get = ['$http', 'UtilsService', function ($http, UtilsService) {
  return new PosCloudConfigurationService(this.endpoint, $http, UtilsService.unwrapAcmeResponse);
}];

PosCloudConfigurationServiceProvider.$inject = [];
